/*
 * This contains all the text wall location options
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  noWalls: {
    id: 'cwt.translations.NoWalls',
    defaultMessage: 'No walls',
  },
  oneWall: {
    id: 'cwt.translations.OneWall',
    defaultMessage: 'One wall',
  },
  twoWalls: {
    id: 'cwt.translations.TwoWalls',
    defaultMessage: 'Two walls',
  },
  threeWalls: {
    id: 'cwt.translations.ThreeWalls',
    defaultMessage: 'Three walls',
  },
  fourWalls: {
    id: 'cwt.translations.FourWalls',
    defaultMessage: 'Four walls',
  },
  fiveWalls: {
    id: 'cwt.translations.FiveWalls',
    defaultMessage: 'Five walls',
  },
  sixWalls: {
    id: 'cwt.translations.SixWalls',
    defaultMessage: 'Six walls',
  },
});
